var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m0 315.03c0-146.354 118.643-264.996 264.996-264.996h55.004v-35.005c0-12.987 15.382-19.837 25.034-11.149l100 90c6.621 5.959 6.621 16.34 0 22.299l-100 90c-9.652 8.688-25.034 1.837-25.034-11.149v-34.996h-51.157c-105.164 0-199.931 63.465-239.973 160.707-6.256 15.193-28.87 10.72-28.87-5.711z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m512 196.97c0 146.353-118.643 264.996-264.996 264.996h-55.004v35.004c0 12.987-15.382 19.837-25.034 11.149l-100-90c-6.621-5.959-6.621-16.34 0-22.299l100-90c9.653-8.688 25.034-1.837 25.034 11.149v34.996h51.157c105.164 0 199.931-63.465 239.973-160.707 6.256-15.192 28.87-10.719 28.87 5.712z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlter);
export default __webpack_public_path__ + "static/media/alter.d0fcc9940e4ee4ba892a6446db787a40.svg";
export { ForwardRef as ReactComponent };